import type { RestoredDataState } from '@excalidraw/excalidraw/types/data/restore';
import type { ExcalidrawElement } from '@excalidraw/excalidraw/types/element/types';
import type {
    BinaryFiles as ExcalidrawBinaryFiles,
    ExcalidrawImperativeAPI,
} from '@excalidraw/excalidraw/types/types';

import { createCacheSingleton } from '@gitbook/util-suspense-cache';

export async function excalidraw() {
    return import('./excalidraw.lazy');
}

export const excalidrawSuspense = createCacheSingleton(() => excalidraw());

export type {
    RestoredDataState,
    ExcalidrawImperativeAPI,
    ExcalidrawElement,
    ExcalidrawBinaryFiles,
};
